function loadLottieLibrary() {
  if (window.lottie) return Promise.resolve(window.lottie);
  if (window.__macraLottiePromise) return window.__macraLottiePromise;

  window.__macraLottiePromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.12.2/lottie.min.js';
    script.async = true;
    script.onload = () => resolve(window.lottie);
    script.onerror = () => reject(new Error('Unable to load Lottie library.'));
    document.head.appendChild(script);
  });

  return window.__macraLottiePromise;
}

function initLottieIcons(root = document) {
  const icons = root.querySelectorAll('.lottie-icon[data-lottie-src]:not([data-lottie-initialized])');
  if (!icons.length) return;

  loadLottieLibrary()
    .then((lottie) => {
      icons.forEach((icon) => {
        icon.dataset.lottieInitialized = 'true';

        lottie.loadAnimation({
          container: icon,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: icon.dataset.lottieSrc
        });
      });
    })
    .catch((error) => {
      console.error(error);
    });
}

document.addEventListener('DOMContentLoaded', function () {

  initLottieIcons();

  function setResultsWidth(wrapper) {

    const items = wrapper.querySelectorAll('.results-percentage');

    if (!items.length) return;

    let maxWidth = 0;

    items.forEach((item) => {
      item.style.width = 'fit-content';
    });

    items.forEach((item) => {
      const width = item.getBoundingClientRect().width;

      if (width > maxWidth) {
        maxWidth = width;
      }
    });

    items.forEach((item) => {
      item.style.width = `${maxWidth}px`;
    });

  }

  document.querySelectorAll('.product_tabbing_main_inner').forEach((wrapper) => {
    setResultsWidth(wrapper);
  });

  document.querySelectorAll('.tab-a').forEach(function (tabLink) {

    tabLink.addEventListener('click', function () {

      const wrapper = this.closest('.product_tabbing_main_inner');

      if (!wrapper) return;

      const id = this.getAttribute('data-id');

      wrapper.querySelectorAll('.tab').forEach(function (tab) {
        tab.classList.remove('tab-active');
      });

      const activeTab = wrapper.querySelector('.tab[data-id="' + id + '"]');

      if (activeTab) {
        activeTab.classList.add('tab-active');
      }

      wrapper.querySelectorAll('.tab-a').forEach(function (link) {
        link.classList.remove('active-a');
      });

      wrapper.querySelectorAll('.tab-a[data-id="' + id + '"]').forEach(function (link) {
        link.classList.add('active-a');
      });

      setResultsWidth(wrapper);

      window.dispatchEvent(new Event('resize'));

    });

  });




    //video toggle js
    
  const videoCards = document.querySelectorAll(".trs-card--video");

  videoCards.forEach((card) => {

    const video = card.querySelector("video");
    const playBtn = card.querySelector("[data-trs-play]");

    if (!video || !playBtn) return;

    function stopOtherVideos(currentVideo) {
      document.querySelectorAll(".trs-card--video video").forEach((vid) => {
        if (vid !== currentVideo) {
          vid.pause();
          vid.currentTime = 0;

          const btn = vid
            .closest(".trs-card--video")
            .querySelector("[data-trs-play]");

          if (btn) {
            btn.style.opacity = "1";
            btn.style.pointerEvents = "auto";
          }
        }
      });
    }

    function togglePlay() {
      if (video.paused || video.ended) {

        stopOtherVideos(video);

        video.play();

      } else {
        video.pause();
      }
    }

    playBtn.addEventListener("click", togglePlay);
    video.addEventListener("click", togglePlay);


    video.addEventListener("playing", () => {
      playBtn.style.opacity = "0";
      playBtn.style.pointerEvents = "none";
    });

    video.addEventListener("pause", () => {
      playBtn.style.opacity = "1";
      playBtn.style.pointerEvents = "auto";
    });

    video.addEventListener("ended", () => {
      playBtn.style.opacity = "1";
      playBtn.style.pointerEvents = "auto";
    });

  });

      var swiper = new Swiper(".pdp_testimonials_slider", {
      spaceBetween: 10,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });


const items = document.querySelectorAll(".product-results_inner");

if (!items.length) return;

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const raw = entry.target.getAttribute("data-fill") || "";

        // Only run if value contains %
        if (!raw.includes("%")) return;

        const num = parseFloat(raw.replace("%", "")) || 0;

        entry.target.style.setProperty("--fill", `${num}%`);
        entry.target.classList.add("animate");

        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.4 }
);

items.forEach((el) => observer.observe(el));


  //

  //nutrition facts popup

let scrollY = 0;

function lockScroll() {
  scrollY = window.scrollY;

  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
}

function unlockScroll() {
  const y = Math.abs(parseInt(document.body.style.top || "0"));

  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";

  requestAnimationFrame(() => {
    window.scrollTo({
      top: y,
      behavior: "instant"
    });
  });
}
  document.querySelectorAll(".open_nutrition_facts_popup").forEach(function (button) {
    button.addEventListener("click", function () {
      var ID = this.getAttribute("popup_id");
      if (ID) {
        document.querySelector("." + ID)?.classList.add("open");
        document.body.classList.add("overflow-hidden");
        if (window.innerWidth <= 768) {
        lockScroll();
        }
      }
    });
  });
  document.querySelectorAll(".close_nutrition_facts_popup, .Product_nutition_facts_mainpopup_overlay_new")
    .forEach(function (button) {
      button.addEventListener("click", function () {
        document.querySelectorAll(".Product_nutition_facts_mainpopup_new")
          .forEach(el => el.classList.remove("open"));
        setTimeout(() => {
        document.body.classList.remove("overflow-hidden");
        }, 500);
        if (window.innerWidth <= 768) {
        unlockScroll();
        }
      });
    });
});

document.addEventListener('shopify:section:load', function (event) {
  initLottieIcons(event.target);
});


document.querySelectorAll(".words").forEach((container) => {
  if (container.dataset.inited) return;
  container.dataset.inited = "1";

  container.innerHTML += container.innerHTML;

  const items = container.querySelectorAll("strong");
  const originalCount = items.length / 2;

  let tl;

  const build = () => {
    const wordHeight = items[0]?.offsetHeight || 0;
    if (!wordHeight) return;

    if (tl) tl.kill();
    gsap.set(container, { y: 0 });

    tl = gsap.timeline({ repeat: -1 });

    for (let i = 1; i <= originalCount; i++) {
      tl.to(container, {
        y: -wordHeight * i,
        duration: 0.35,
        ease: "power2.inOut"
      })
      .to({}, { duration: 1 });
    }

    tl.set(container, { y: 0 });
  };

  requestAnimationFrame(build);
  window.addEventListener("resize", () => requestAnimationFrame(build));
});


document.addEventListener("DOMContentLoaded", () => {

  // thumb slider with fly-tab animation
  var swiper = new Swiper(".thumbslider", {
    slidesPerView: 3,
    spaceBetween: 0,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    mousewheel: true,

    breakpoints: {
      750: {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
      },
    },
  });

  var swiper2 = new Swiper(".mainslider", {
    spaceBetween: 24,
    slidesPerView: 1,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: { swiper: swiper },
    breakpoints: {
      640: { slidesPerView: 1 },
      750: { slidesPerView: 1.4 },
      1024: { slidesPerView: 1.4 },
      1366: { slidesPerView: "auto" },
    },
  });

  // const slider = swiper.el;
  // if (!slider || !slider.classList.contains("js-fly-tab")) return;
    const slider = document.querySelector(".thumbslider");
  if (!slider || !slider.classList.contains("js-fly-tab")) return;

  let fly = slider.querySelector(".fly-tab");
  if (!fly) {
    fly = document.createElement("div");
    fly.className = "fly-tab";
    fly.innerHTML = "<span></span>";
    slider.appendChild(fly);
  }

  const flyText = fly.querySelector("span");
  const DURATION = 350;

  const mqNoAnim = window.matchMedia("(max-width: 991px)");
  const isNoAnim = () =>
    mqNoAnim.matches || (navigator.maxTouchPoints > 0 && window.innerWidth < 749);

  function placeFlyTo(slide, textNow) {
    if (!slide) return;

    const sRect = slider.getBoundingClientRect();
    const aRect = slide.getBoundingClientRect();

    const left = aRect.left - sRect.left;
    const top = aRect.top - sRect.top;

    fly.style.width = aRect.width + "px";
    fly.style.height = aRect.height + "px";
    fly.style.top = top + "px";
    fly.style.transform = `translateX(${left}px)`;

    if (typeof textNow === "string") flyText.textContent = textNow;
  }
  let lastText = "";
  function animateTo(slide) {
    if (!slide) return;


    if (isNoAnim()) {
      const txt = (slide.textContent || "").trim();
      lastText = txt;
      clearTimeout(animateTo._t);
      placeFlyTo(slide, txt);
      return;
    }

    const nextText = (slide.textContent || "").trim();

    if (!lastText) {
      lastText = nextText;
      placeFlyTo(slide, nextText);
      return;
    }

    placeFlyTo(slide, lastText);

    clearTimeout(animateTo._t);
    animateTo._t = setTimeout(() => {
      flyText.textContent = nextText;
      lastText = nextText;
    }, Math.floor(DURATION / 2));
  }
  function syncFlyVisibility() {
    fly.style.display = isNoAnim() ? "none" : "";
  }
  syncFlyVisibility();
  mqNoAnim.addEventListener?.("change", syncFlyVisibility);
  window.addEventListener("resize", syncFlyVisibility);
  function pageThumbWindowTo(i) {

    if (swiper.params.slidesPerView === "auto") return;

    const perView = swiper.slidesPerViewDynamic();
    const maxStart = Math.max(0, swiper.slides.length - perView);

    let start = swiper.activeIndex; // current window start
    let end = start + perView - 1; // current window end (2 slots)


    if (i > end) {
      start = i; // make it first visible -> shows next
    } else if (i < start) {
      start = i - (perView - 1); 
    } else {
      // If target is exactly at the window edges, "page"
      if (i === end && i < swiper.slides.length - 1) {
        start = i; // 1->2 makes [2,3]
      } else if (i === start && i > 0) {
        start = i - (perView - 1); // 3->2 makes [1,2]
      } else {
        return; // already nicely visible, no need to move
      }
    }

    // clamp + slide
    start = Math.max(0, Math.min(start, maxStart));
    swiper.slideTo(start);
  }
  function syncFromThumbs() {
    const active =
      slider.querySelector(".swiper-slide-thumb-active") ||
      slider.querySelector(".swiper-slide-active") ||
      swiper.slides?.[swiper.activeIndex];

    animateTo(active);
  }
  let mainDragging = false;

  function syncFromMain() {

    if (isNoAnim() && mainDragging) return;

    const i = swiper2.realIndex;


    if (!isNoAnim()) {
      pageThumbWindowTo(i);
    }

    swiper.updateSlidesClasses();

    const thumb = swiper.slides?.[i];
    if (thumb) animateTo(thumb);
  }
  swiper.on("slideChange", syncFromThumbs);
  swiper.on("transitionEnd", syncFromThumbs);

  swiper.on("click", () => {
    const i = swiper.clickedIndex;
    if (i == null) return;

    swiper2.slideTo(i);


    pageThumbWindowTo(i);
    swiper.updateSlidesClasses();

    const thumb = swiper.slides?.[i];
    if (thumb) animateTo(thumb);
  });

  swiper2.on("realIndexChange", syncFromMain);
  swiper2.on("transitionEnd", () => {
    mainDragging = false;
    syncFromMain();
  });

  function bindDesktopDragSync() {
    swiper2.off("setTranslate", syncFromMain);

    if (!isNoAnim()) {
      swiper2.on("setTranslate", syncFromMain);
    }
  }

  swiper2.on("touchStart", () => {
    if (isNoAnim()) mainDragging = true;
  });

  swiper2.on("touchEnd", () => {
    if (isNoAnim()) {
      mainDragging = false;
      syncFromMain();
    }
  });

  bindDesktopDragSync();

  window.addEventListener("resize", () => {
    bindDesktopDragSync();
    syncFromMain();
  });

  window.addEventListener("load", syncFromMain);

  syncFromMain();
});




/* Accordian Start */
function slideUp(element, duration = 300) {
    element.style.height = element.scrollHeight + "px";
    element.offsetHeight; // force repaint

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = "0px";
    element.style.overflow = "hidden";

    setTimeout(() => {
        element.style.display = "none";
        element.style.removeProperty("height");
        element.style.removeProperty("overflow");
        element.style.removeProperty("transition");
    }, duration);
}

function slideDown(element, duration = 300) {
    element.style.display = "block";
    let height = element.scrollHeight;

    element.style.height = "0px";
    element.style.overflow = "hidden";
    element.offsetHeight;

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + "px";

    setTimeout(() => {
        element.style.removeProperty("height");
        element.style.removeProperty("overflow");
        element.style.removeProperty("transition");
    }, duration);
}

function initCustomAccordion(root) {
    const scope = root || document;

    scope.querySelectorAll(".accordion").forEach(acc => {
        const items = acc.querySelectorAll("li");

        items.forEach(item => {
            if (item.dataset.accordionBound === "true") return;
            item.dataset.accordionBound = "true";

            const question = item.querySelector(".question");
            const answer = item.querySelector(".answer");

            if (!question || !answer) return;

            // Initial state
            if (item.classList.contains("open")) {
                answer.style.display = "block";
            } else {
                answer.style.display = "none";
            }

            question.addEventListener("click", () => {
                const isOpen = item.classList.contains("open");

                // Close others
                items.forEach(i => {
                    if (i === item) return;
                    i.classList.remove("open");

                    const a = i.querySelector(".answer");
                    if (a && a.style.display !== "none") {
                        slideUp(a, 300);
                    }
                });

                // Toggle current
                if (isOpen) {
                    item.classList.remove("open");
                    slideUp(answer, 300);
                } else {
                    item.classList.add("open");
                    slideDown(answer, 300);

                    // Smooth scroll after open
                    setTimeout(() => {
                        const container = item.closest(".Product_meta_collapsible_main_new");
                        if (container) {
                            const offset = 100;
                            const y = question.getBoundingClientRect().top + window.pageYOffset - offset;

                            window.scrollTo({
                                top: y,
                                behavior: "smooth"
                            });
                        }
                    }, 300);
                }
            });
        });
    });
}

window.initCustomAccordion = initCustomAccordion;
initCustomAccordion(document);
/* Accordian End */


(function () {
  const stickyRoots = document.querySelectorAll(".sticky-add-to-cart");
  if (!stickyRoots.length) return;

  function getActivePlanTitle() {
    const activeRadio = document.querySelector(
      ".subscription-plan-comparison__plan-container .subscription-plan-comparison__radio.is-active"
    );
    if (!activeRadio) return "";

    const planContainer =
      activeRadio.closest(".subscription-plan-comparison__plan-container") || activeRadio.parentElement;

    if (!planContainer) return "";

    const totalDays = planContainer.dataset.totalDays?.trim();
    const saveBadgeText = planContainer
      .querySelector(".subscription-plan-comparison__save-badge")
      ?.textContent?.replace(/\s+/g, " ")
      .trim();
    const saveMatch = saveBadgeText?.match(/SAVE\s+(\d+%)/i);

    if (totalDays && saveMatch?.[1]) {
      return `${totalDays} day Supply | Save ${saveMatch[1]}`;
    }

    const titleEl = planContainer.querySelector(".subscription-plan-comparison__title");
    return titleEl ? titleEl.textContent.trim() : "";
  }

  function renderToAllStickies() {
    const title = getActivePlanTitle() || "";

    stickyRoots.forEach((root) => {
      const desktopEl = root.querySelector('[data-sticky-plan-title="desktop"]');
      const mobileEl = root.querySelector('[data-sticky-plan-title="mobile"]');

      if (desktopEl) desktopEl.textContent = title;
      if (mobileEl) mobileEl.textContent = title;
    });
  }

  renderToAllStickies();

  const comparisonRoot = document.querySelector(".subscription-plan-comparison");
  if (comparisonRoot) {
    comparisonRoot.addEventListener("click", () => requestAnimationFrame(renderToAllStickies));
    comparisonRoot.addEventListener("change", () => requestAnimationFrame(renderToAllStickies));

    const mo = new MutationObserver(() => renderToAllStickies());
    mo.observe(comparisonRoot, { subtree: true, attributes: true, childList: true, characterData: true });
  }
})();


// document.addEventListener("DOMContentLoaded", function () {
//   function setTabsTopByMaxHeight() {
//     var wrappers = document.querySelectorAll(".product_tabbing_main .product_tabbing_main_inner");

//     wrappers.forEach(function (wrapper) {
//       var tabs = wrapper.querySelector(".tabs");
//       if (!tabs) return;

//       var contentItems = wrapper.querySelectorAll(".tab-content_inner_left_top");
//       if (!contentItems.length) return;

//       var maxHeight = 0;

//       contentItems.forEach(function (item) {
//         var height = item.offsetHeight;
//         if (height > maxHeight) {
//           maxHeight = height;
//         }
//       });

//       var extraSpacing = 80; // adjust spacing here
//       tabs.style.top = (maxHeight + extraSpacing) + "px";
//     });
//   }

//   setTabsTopByMaxHeight();
//   window.addEventListener("load", setTabsTopByMaxHeight);
//   window.addEventListener("resize", setTabsTopByMaxHeight);
// });

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".product_tabbing_main")) return;

  function measureTabTopContent(tab) {
    var content = tab.querySelector(".tab-content_inner_left_top");
    if (!content) return 0;

    var oldTabDisplay = tab.style.display;
    var oldTabPosition = tab.style.position;
    var oldTabVisibility = tab.style.visibility;

    tab.style.display = "block";
    tab.style.position = "absolute";
    tab.style.visibility = "hidden";

    var height = content.offsetHeight;

    tab.style.display = oldTabDisplay;
    tab.style.position = oldTabPosition;
    tab.style.visibility = oldTabVisibility;

    return height;
  }

  function setTabsTopByMaxHeight() {
    var wrappers = document.querySelectorAll(".product_tabbing_main .product_tabbing_main_inner");

    wrappers.forEach(function (wrapper) {
      var tabs = wrapper.querySelector(".tabs");
      var allTabs = wrapper.querySelectorAll(".tab");

      if (!tabs || !allTabs.length) return;

      var maxHeight = 0;

      allTabs.forEach(function (tab) {
        var height = 0;

        if (tab.classList.contains("tab-active")) {
          var activeContent = tab.querySelector(".tab-content_inner_left_top");
          height = activeContent ? activeContent.offsetHeight : 0;
        } else {
          height = measureTabTopContent(tab);
        }

        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      var extraSpacing = 80;
      tabs.style.top = (maxHeight + extraSpacing) + "px";
    });
  }

  setTabsTopByMaxHeight();
  window.addEventListener("load", setTabsTopByMaxHeight);
  window.addEventListener("resize", setTabsTopByMaxHeight);
  setTimeout(setTabsTopByMaxHeight, 500);
});

  const sideBarSlider = document.querySelector("[js-side-bar-product-slider]")
  if(sideBarSlider){
    new Swiper(sideBarSlider, {
      slidesPerView: 1,
      spaceBetween: 12,
      mousewheel: { forceToAxis: true },
      direction: 'horizontal',
      observer: true,
      observeParents: true,   
      pagination: {
        el: ".cs-swiper-pagination",
        clickable: true,
      },  
    });
  }
